/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { AiringOffer } from 'client-code/airing';
import { TOfferPreviewCustomData } from '../types/TOfferPreviewCustomData';

export class VideoPlayerUtils {
    TAG: string = 'VideoPlayerUtils';

    private static oVideoPlayerUtils: VideoPlayerUtils;

    private airingData: AiringOffer[] = [];

    private previewData: TOfferPreviewCustomData = {};

    static getInstance(): VideoPlayerUtils {
        if (!VideoPlayerUtils.oVideoPlayerUtils)
            VideoPlayerUtils.oVideoPlayerUtils = new VideoPlayerUtils();
        return VideoPlayerUtils.oVideoPlayerUtils;
    }

    public getAiringData(): AiringOffer[] {
        return this.airingData;
    }

    public getPreviewData(): TOfferPreviewCustomData {
        return this.previewData;
    }

    public setAiringData(airingData: any) {
        this.airingData = airingData;
    }

    public setPreviewData(previewData: TOfferPreviewCustomData) {
        this.previewData = previewData;
    }
}
